import React from "react";
import folder1 from "../../assets/folder-1x.png";
import folder15 from "../../assets/folder-1.5x.png";
import folder2 from "../../assets/folder-2x.png";
import folder3 from "../../assets/folder-3x.png";
import { Box, LinearProgress, Typography } from "@mui/material";
import { BetaBox } from "../../shared/BetaBox";

interface Props {
  title: string;
  step?: number;
  totalSteps?: number;
  completedAll?: boolean;
  hideImage?: boolean;
  showBeta?: boolean;
}

export const Header = ({
  title,
  step = 1,
  totalSteps = 3,
  completedAll = false,
  hideImage = false,
  showBeta = false,
}: Props): JSX.Element => {
  const getCompletionBarPercent = () => {
    const actualComplete = Math.floor(((step - 1) / totalSteps) * 100);
    const fakeFirstComplete = Math.floor(((1 / totalSteps) * 100) / 2);
    if (completedAll) {
      return 100;
    } else {
      return actualComplete === 0 ? fakeFirstComplete : actualComplete;
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        {!hideImage && (
          <img
            src={folder1}
            srcSet={`${folder15} 1.5x, ${folder2} 2x, ${folder3} 3x`}
            alt="Probate packet"
            title="Probate packet"
            style={{ width: 40 }}
          />
        )}
        <Typography variant="h3" component="h1" sx={{ ml: !hideImage ? 2 : 0 }}>
          {title}
        </Typography>
        {showBeta && <BetaBox />}
      </Box>

      {totalSteps !== 0 && (
        <LinearProgress
          sx={{
            mt: 1,
          }}
          variant="determinate"
          value={getCompletionBarPercent()}
          color="secondary"
        />
      )}
    </Box>
  );
};
